'use client';

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import { BLUR_PLACEHOLDER } from '@/lib/componentutills';
type Slide = {
  title: string;
  image?: string;
  slug?: string;
  storyTemplate?: string;
};
type SliderProps = {
  slides?: Slide[];
  intervalMs?: number;
  width?: number | string;
  ratio?: number | string;
  showControls?: boolean;
  className?: string;
  /**
   * LCP candidate. Defaults to false: this component is used for webstory rails
   * where six sliders render side by side, and hardcoding `priority` made every
   * one of them emit a <link rel="preload"> (6 of the home page's 7 image
   * preloads) and load eagerly. The builder grants priority to the single first
   * image of the first component in the hero column — see MultiComponentRenderer.
   */
  priority?: boolean;
};
export default function Slider(t0) {
  const $ = _c(28);
  const {
    slides,
    width: t1,
    ratio: t2,
    className,
    priority: t3
  } = t0;
  const width = t1 === undefined ? "100%" : t1;
  const ratio = t2 === undefined ? "183 / 280" : t2;
  const priority = t3 === undefined ? false : t3;
  const firstSlide = slides?.[0];
  if (!firstSlide) {
    return null;
  }
  let t4;
  if ($[0] !== firstSlide.slug) {
    t4 = () => {
      if (!firstSlide.slug) {
        return;
      }
      window.open(`/${firstSlide.slug}`, "_blank");
    };
    $[0] = firstSlide.slug;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const handleClick = t4;
  let t5;
  if ($[2] !== ratio || $[3] !== width) {
    t5 = {
      position: "relative",
      overflow: "hidden",
      width,
      aspectRatio: ratio
    };
    $[2] = ratio;
    $[3] = width;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = firstSlide.slug ? "pointer" : "default";
  let t7;
  if ($[5] !== t6) {
    t7 = {
      position: "absolute",
      inset: 0,
      cursor: t6
    };
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = firstSlide.image || "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png";
  const t9 = priority ? "eager" : "lazy";
  const t10 = typeof width === "number" ? `${width}px` : "(max-width: 768px) 100vw, 400px";
  let t11;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      objectFit: "cover"
    };
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== firstSlide.title || $[9] !== priority || $[10] !== t10 || $[11] !== t8 || $[12] !== t9) {
    t12 = <Image src={t8} alt={firstSlide.title} fill={true} priority={priority} loading={t9} sizes={t10} style={t11} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} />;
    $[8] = firstSlide.title;
    $[9] = priority;
    $[10] = t10;
    $[11] = t8;
    $[12] = t9;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  let t14;
  let t15;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div style={{
      position: "absolute",
      inset: 0,
      background: "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.25) 50%, transparent)",
      pointerEvents: "none"
    }} />;
    t14 = {
      position: "absolute",
      left: 12,
      right: 12,
      bottom: 12,
      userSelect: "none",
      pointerEvents: "none"
    };
    t15 = {
      color: "white",
      fontWeight: 600,
      fontSize: 14,
      lineHeight: "18px",
      textShadow: "0 1px 1px rgba(0,0,0,0.8)",
      display: "-webkit-box",
      WebkitLineClamp: 3,
      WebkitBoxOrient: "vertical",
      overflow: "hidden"
    };
    $[14] = t13;
    $[15] = t14;
    $[16] = t15;
  } else {
    t13 = $[14];
    t14 = $[15];
    t15 = $[16];
  }
  let t16;
  if ($[17] !== firstSlide.title) {
    t16 = <div style={t14}><p style={t15}>{firstSlide.title}</p></div>;
    $[17] = firstSlide.title;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== handleClick || $[20] !== t12 || $[21] !== t16 || $[22] !== t7) {
    t17 = <div style={t7} onClick={handleClick}>{t12}{t13}{t16}</div>;
    $[19] = handleClick;
    $[20] = t12;
    $[21] = t16;
    $[22] = t7;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== className || $[25] !== t17 || $[26] !== t5) {
    t18 = <div className={className} style={t5}>{t17}</div>;
    $[24] = className;
    $[25] = t17;
    $[26] = t5;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  return t18;
}